
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"199","height":"54","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.381 11.128L14.101 5 6.408 16.801 5 34.495l15.478 4.088M36.79 11.128l-4.63 19.404v12.255l7.87 3.064 14.818-4.596m0 0l1.39-27.574m-1.39 27.574L56.238 53m12.277-1.021l-1.454-21.447 2.604-18.384m2.778 4.085l13.428 2.043.927 12.256-14.355 3.574M97.91 51.979l2.316-17.873-2.316-24m-5.093 9.191l15.28-3.064h10.65l2.778 14.299-28.708 8.17m12.965-2.043l21.763 9.703m4.167-36.257l4.63 20.427 1.389 19.404m4.168-37.788l12.965-2.043 13.428 1.532m-13.428 2.043l2.778 30.639 5.556 2.043m10.65-36.257v21.958L175.7 45.34l21.3-5.617m-18.521-9.191l15.743-4.596m-16.67-10.724l16.67-3.575","stroke":"#1CE0B9","stroke-width":"8"}})])
          )
        }
      }
    